import React from "react";

export default function PasswordRequirements({ password }) {
  const passwordValue = password || "";
  const requirements = [
    { label: "At least 6 characters", isMet: passwordValue.length >= 6 },
    { label: "At least one lowercase letter", isMet: /[a-z]/.test(passwordValue) },
    { label: "At least one uppercase letter", isMet: /[A-Z]/.test(passwordValue) },
    { label: "At least one number", isMet: /[0-9]/.test(passwordValue) },
    { label: "At least one special character (!@#$%^&*)", isMet: /[!@#$%^&*]/.test(passwordValue) },
  ];

  return (
    <ul className="mt-3 space-y-1 text-sm" aria-live="polite">
      {requirements.map((requirement) => (
        <li
          key={requirement.label}
          className={`flex items-center gap-2 ${requirement.isMet ? "text-green-600" : "text-[#757575]"}`}
        >
          <span aria-hidden="true" className="w-4 text-center">
            {requirement.isMet ? <>&#10003;</> : <>&#9675;</>}
          </span>
          {requirement.label}
        </li>
      ))}
    </ul>
  );
}
